import { render, staticRenderFns } from "./partnerDash.vue?vue&type=template&id=ff79a1c8&scoped=true&"
import script from "./partnerDash.vue?vue&type=script&lang=js&"
export * from "./partnerDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff79a1c8",
  null
  
)

export default component.exports